import React, { useContext, useState } from 'react';

import Button from '@mui/material/Button';

import AppContext from '../../pages/app/context';

import { DialogoOpcao, DialogoCaixa } from '../../components/dialogo/Dialogo';

import { List, ListItem } from '@mui/material';
import ListItemText from '@mui/material/ListItemText';

const arrayOpcoes = [
  {
    value: 1,
    desc: 'opcao1.com',
    selected: false,
  },
  {
    value: 2,
    desc: 'opcao2.com',
    selected: false,
  },
  {
    value: 3,
    desc: 'opcao3.com',
    selected: false,
  },
  {
    value: 3,
    desc: 'opcao3.com',
    selected: false,
  },
  {
    value: 3,
    desc: 'opcao3.com',
    selected: false,
  },
  {
    value: 3,
    desc: 'opcao3.com',
    selected: false,
  },
  {
    value: 3,
    desc: 'opcao3.com',
    selected: false,
  },
  {
    value: 3,
    desc: 'opcao3.com',
    selected: false,
  },
  {
    value: 3,
    desc: 'opcao3.com',
    selected: false,
  },
  {
    value: 3,
    desc: 'opcao3.com',
    selected: false,
  },
];

const titulo = 'Usar o serviço de localização do Google?';
const texto =
  'Deixe o Google ajudar os aplicativos a determinar a localização. Isso significa enviar dados de localização anônimos para o Google, mesmo quando nenhum aplicativo estiver em execução.';

const text = 'Dados salvos!';
const tipo = 'success';
// tipos de alert = "error", "warning", "info", "success"

export default function Componentes() {
  const [selecaoOpcao, setSelecaoOpcao] = useState('');
  const [selecionarOpcao, setSelecionarOpcao] = useState(false);
  const [caixaTextoOpen, setCaixaTextoOpen] = useState(false);
  const [btnConfirmar, setBtnConfirmar] = useState(false);
  const [btnCancelar, setBtnCancelar] = useState(false);
  const [listaSelecionados, setListaSelecionados] = useState([]);

  const { notification } = useContext(AppContext);

  const handleChange = (opcao) => {
    setSelecaoOpcao(opcao.desc);
    // setSelecionarOpcao(false);
  };

  const confirmar = () => {
    setBtnConfirmar(true);
    setCaixaTextoOpen(false);
  };

  const cancelar = () => {
    setBtnCancelar(true);
    setCaixaTextoOpen(false);
  };

  const salvarLista = (lista) => {
    setListaSelecionados(lista);
    setSelecionarOpcao(false);
  };

  const handleAlert = () => {
    notification(tipo, text);
  };

  return (
    <>
      <div style={{ textAlign: 'center' }}>
        <div>
          <h4>selecionado:</h4>
          <List sx={{ pt: 0 }}>
            {listaSelecionados.map((opcao, key) => (
              <ListItem style={{ paddingBottom: 0 }} key={key}>
                <ListItemText
                  style={{ textAlign: 'center' }}
                  primary={opcao.desc}
                />
              </ListItem>
            ))}
          </List>
        </div>

        <br />
        <Button variant="outlined" onClick={() => setSelecionarOpcao(true)}>
          Abrir caixa de opções
        </Button>
        <br />
        {selecionarOpcao && (
          <DialogoOpcao
            opcoes={arrayOpcoes}
            selecaoOpcao={handleChange}
            salvarLista={salvarLista}
            onClose={() => setSelecionarOpcao(false)}
          />
        )}

        <br />
        <DialogoCaixa
          texto={texto}
          titulo={titulo}
          caixaTextoOpen={caixaTextoOpen}
          confirmar={confirmar}
          cancelar={cancelar}
        ></DialogoCaixa>
        <Button variant="outlined" onClick={() => setCaixaTextoOpen(true)}>
          Abrir caixa de dialogo
        </Button>
        <br />
        <div>
          <br />
          <Button variant="outlined" onClick={handleAlert}>
            Clique para mensagem
          </Button>
        </div>
      </div>
    </>
  );
}
